import { typesenseAdapter } from "./typesense-adapter";

export function searchClient(query_by, inFix, token, serverType, sort_by) {
  const typesenseInstantsearchAdapter = typesenseAdapter(
    query_by,
    inFix,
    token,
    serverType,
    sort_by
  );
  const baseClient = typesenseInstantsearchAdapter.searchClient;

  // Wrap the client so that when query is "*" we sort by newest first; otherwise use relevance
  const wrappedClient = {
    ...baseClient,
    search(requests) {
      try {
        const adjusted = requests.map((req) => {
          const params = req?.params || {};
          const q = params.query ?? params.q;
          // Only inject sort for wildcard searches when no explicit sort is already set
          if (q === "*" && !params.sort_by) {
            return {
              ...req,
              params: { ...params, sort_by: "date:desc" },
            };
          }
          return req;
        });
        return baseClient.search(adjusted);
      } catch (_) {
        // Fallback to base behavior if anything unexpected happens
        return baseClient.search(requests);
      }
    },
  };

  return wrappedClient;
}
